"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Show/hide modals

var SHOW_MODAL = exports.SHOW_MODAL = "SHOW_MODAL";
var DISMISS_MODAL = exports.DISMISS_MODAL = "DISMISS_MODAL";

// search
var SAVE_QUERY_INFO = exports.SAVE_QUERY_INFO = "SAVE_QUERY_INFO";
var SET_SEARCH_QUERY = exports.SET_SEARCH_QUERY = "SET_SEARCH_QUERY";

var FETCH_AUTOCOMPLETE_TERMS = exports.FETCH_AUTOCOMPLETE_TERMS = "FETCH_AUTOCOMPLETE_TERMS";
var FETCH_AUTOCOMPLETE_TERMS_SUCCESS = exports.FETCH_AUTOCOMPLETE_TERMS_SUCCESS = "FETCH_AUTOCOMPLETE_TERMS_SUCCESS";
var FETCH_AUTOCOMPLETE_TERMS_FAILURE = exports.FETCH_AUTOCOMPLETE_TERMS_FAILURE = "FETCH_AUTOCOMPLETE_TERMS_FAILURE";

// collections
var FETCH_FEATURED_COLLECTIONS_METADATA = exports.FETCH_FEATURED_COLLECTIONS_METADATA = "FETCH_FEATURED_COLLECTIONS_METADATA";
var FETCH_FEATURED_COLLECTIONS_METADATA_SUCCESS = exports.FETCH_FEATURED_COLLECTIONS_METADATA_SUCCESS = "FETCH_FEATURED_COLLECTIONS_METADATA_SUCCESS";
var FETCH_FEATURED_COLLECTIONS_METADATA_FAILURE = exports.FETCH_FEATURED_COLLECTIONS_METADATA_FAILURE = "FETCH_FEATURED_COLLECTIONS_METADATA_FAILURE";

var FETCH_FORT_COLLECTION = exports.FETCH_FORT_COLLECTION = "FETCH_FORT_COLLECTION";
var FETCH_FORT_COLLECTION_SUCCESS = exports.FETCH_FORT_COLLECTION_SUCCESS = "FETCH_FORT_COLLECTION_SUCCESS";
var FETCH_FORT_COLLECTION_FAILURE = exports.FETCH_FORT_COLLECTION_FAILURE = "FETCH_FORT_COLLECTION_FAILURE";

var PREVIEW_COLLECTION_ICONS = exports.PREVIEW_COLLECTION_ICONS = "PREVIEW_COLLECTION_ICONS";
var PREVIEW_COLLECTION_ICONS_SUCCESS = exports.PREVIEW_COLLECTION_ICONS_SUCCESS = "PREVIEW_COLLECTION_ICONS_SUCCESS";
var PREVIEW_COLLECTION_ICONS_FAILURE = exports.PREVIEW_COLLECTION_ICONS_FAILURE = "PREVIEW_COLLECTION_ICONS_FAILURE";

var SAVE_COLLECTION = exports.SAVE_COLLECTION = "SAVE_COLLECTION";
var SAVE_COLLECTION_SUCCESS = exports.SAVE_COLLECTION_SUCCESS = "SAVE_COLLECTION_SUCCESS";
var SAVE_COLLECTION_FAILURE = exports.SAVE_COLLECTION_FAILURE = "SAVE_COLLECTION_FAILURE";

var DISABLE_COLLECTION = exports.DISABLE_COLLECTION = "DISABLE_COLLECTION";
var DISABLE_COLLECTION_SUCCESS = exports.DISABLE_COLLECTION_SUCCESS = "DISABLE_COLLECTION_SUCCESS";
var DISABLE_COLLECTION_FAILURE = exports.DISABLE_COLLECTION_FAILURE = "DISABLE_COLLECTION_FAILURE";

// users
var LOGOUT_USER = exports.LOGOUT_USER = "LOGOUT_USER";

var GET_CURRENT_USER = exports.GET_CURRENT_USER = "GET_CURRENT_USER";
var GET_CURRENT_USER_SUCCESS = exports.GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
var GET_CURRENT_USER_FAILURE = exports.GET_CURRENT_USER_FAILURE = "GET_CURRENT_USER_FAILURE";

var LOGIN = exports.LOGIN = "LOGIN";
var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = "LOGIN_SUCCESS";
var LOGIN_FAILURE = exports.LOGIN_FAILURE = "LOGIN_FAILURE";

var SIGNUP = exports.SIGNUP = "SIGNUP";
var SIGNUP_SUCCESS = exports.SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
var SIGNUP_FAILURE = exports.SIGNUP_FAILURE = "SIGNUP_FAILURE";

var CREATE_STRIPE_TOKEN = exports.CREATE_STRIPE_TOKEN = "CREATE_STRIPE_TOKEN";
var CREATE_STRIPE_TOKEN_SUCCESS = exports.CREATE_STRIPE_TOKEN_SUCCESS = "CREATE_STRIPE_TOKEN_SUCCESS";
var CREATE_STRIPE_TOKEN_FAILURE = exports.CREATE_STRIPE_TOKEN_FAILURE = "CREATE_STRIPE_TOKEN_FAILURE";

var SAVE_CARD = exports.SAVE_CARD = "SAVE_CARD";
var SAVE_CARD_SUCCESS = exports.SAVE_CARD_SUCCESS = "SAVE_CARD_SUCCESS";
var SAVE_CARD_FAILURE = exports.SAVE_CARD_FAILURE = "SAVE_CARD_FAILURE";

var UPGRADE_BILLING = exports.UPGRADE_BILLING = "UPGRADE_BILLING";
var UPGRADE_BILLING_SUCCESS = exports.UPGRADE_BILLING_SUCCESS = "UPGRADE_BILLING_SUCCESS";
var UPGRADE_BILLING_FAILURE = exports.UPGRADE_BILLING_FAILURE = "UPGRADE_BILLING_FAILURE";

// creators
var FETCH_FEATURED_CREATORS = exports.FETCH_FEATURED_CREATORS = "FETCH_FEATURED_CREATORS";
var FETCH_FEATURED_CREATORS_SUCCESS = exports.FETCH_FEATURED_CREATORS_SUCCESS = "FETCH_FEATURED_CREATORS_SUCCESS";
var FETCH_FEATURED_CREATORS_FAILURE = exports.FETCH_FEATURED_CREATORS_FAILURE = "FETCH_FEATURED_CREATORS_FAILURE";

var TOGGLE_FEATURE_CREATOR = exports.TOGGLE_FEATURE_CREATOR = "TOGGLE_FEATURE_CREATOR";
var TOGGLE_FEATURE_CREATOR_SUCCESS = exports.TOGGLE_FEATURE_CREATOR_SUCCESS = "TOGGLE_FEATURE_CREATOR_SUCCESS";
var TOGGLE_FEATURE_CREATOR_FAILURE = exports.TOGGLE_FEATURE_CREATOR_FAILURE = "TOGGLE_FEATURE_CREATOR_FAILURE";

var FETCH_CREATOR = exports.FETCH_CREATOR = "FETCH_CREATOR";
var FETCH_CREATOR_SUCCESS = exports.FETCH_CREATOR_SUCCESS = "FETCH_CREATOR_SUCCESS";
var FETCH_CREATOR_FAILURE = exports.FETCH_CREATOR_FAILURE = "FETCH_CREATOR_FAILURE";

var DISABLE_CREATOR = exports.DISABLE_CREATOR = "DISABLE_CREATOR";
var DISABLE_CREATOR_SUCCESS = exports.DISABLE_CREATOR_SUCCESS = "DISABLE_CREATOR_SUCCESS";
var DISABLE_CREATOR_FAILURE = exports.DISABLE_CREATOR_FAILURE = "DISABLE_CREATOR_FAILURE";

var SUSPEND_CREATOR = exports.SUSPEND_CREATOR = "SUSPEND_CREATOR";
var SUSPEND_CREATOR_SUCCESS = exports.SUSPEND_CREATOR_SUCCESS = "SUSPEND_CREATOR_SUCCESS";
var SUSPEND_CREATOR_FAILURE = exports.SUSPEND_CREATOR_FAILURE = "SUSPEND_CREATOR_FAILURE";

var UNSUSPEND_CREATOR = exports.UNSUSPEND_CREATOR = "UNSUSPEND_CREATOR";
var UNSUSPEND_CREATOR_SUCCESS = exports.UNSUSPEND_CREATOR_SUCCESS = "UNSUSPEND_CREATOR_SUCCESS";
var UNSUSPEND_CREATOR_FAILURE = exports.UNSUSPEND_CREATOR_FAILURE = "UNSUSPEND_CREATOR_FAILURE";

// Icons

var FETCH_HERO_ICON = exports.FETCH_HERO_ICON = "FETCH_HERO_ICON";
var FETCH_HERO_ICON_SUCCESS = exports.FETCH_HERO_ICON_SUCCESS = "FETCH_HERO_ICON_SUCCESS";
var FETCH_HERO_ICON_FAILURE = exports.FETCH_HERO_ICON_FAILURE = "FETCH_HERO_ICON_FAILURE";

var FETCH_BEST_COLLECTIONS = exports.FETCH_BEST_COLLECTIONS = "FETCH_BEST_COLLECTIONS";
var FETCH_BEST_COLLECTIONS_SUCCESS = exports.FETCH_BEST_COLLECTIONS_SUCCESS = "FETCH_BEST_COLLECTIONS_SUCCESS";
var FETCH_BEST_COLLECTIONS_FAILURE = exports.FETCH_BEST_COLLECTIONS_FAILURE = "FETCH_BEST_COLLECTIONS_FAILURE";

var FETCH_VIEW_MORE_ICONS = exports.FETCH_VIEW_MORE_ICONS = "FETCH_VIEW_MORE_ICONS";
var FETCH_VIEW_MORE_ICONS_SUCCESS = exports.FETCH_VIEW_MORE_ICONS_SUCCESS = "FETCH_VIEW_MORE_ICONS_SUCCESS";
var FETCH_VIEW_MORE_ICONS_FAILURE = exports.FETCH_VIEW_MORE_ICONS_FAILURE = "FETCH_VIEW_MORE_ICONS_FAILURE";

var FETCH_TOTAL_ICON_COUNT = exports.FETCH_TOTAL_ICON_COUNT = "FETCH_TOTAL_ICON_COUNT";
var FETCH_TOTAL_ICON_COUNT_SUCCESS = exports.FETCH_TOTAL_ICON_COUNT_SUCCESS = "FETCH_TOTAL_ICON_COUNT_SUCCESS";
var FETCH_TOTAL_ICON_COUNT_FAILURE = exports.FETCH_TOTAL_ICON_COUNT_FAILURE = "FETCH_TOTAL_ICON_COUNT_FAILURE";

var FETCH_ICONS = exports.FETCH_ICONS = "FETCH_ICONS";
var FETCH_ICONS_SUCCESS = exports.FETCH_ICONS_SUCCESS = "FETCH_ICONS_SUCCESS";
var FETCH_ICONS_FAILURE = exports.FETCH_ICONS_FAILURE = "FETCH_ICONS_FAILURE";

var FETCH_SVG_DATA = exports.FETCH_SVG_DATA = "FETCH_SVG_DATA";
var FETCH_SVG_DATA_SUCCESS = exports.FETCH_SVG_DATA_SUCCESS = "FETCH_SVG_DATA_SUCCESS";
var FETCH_SVG_DATA_FAILURE = exports.FETCH_SVG_DATA_FAILURE = "FETCH_SVG_DATA_FAILURE";

var PLACE_SVG_FROM_ICONLIST = exports.PLACE_SVG_FROM_ICONLIST = "PLACE_SVG_FROM_ICONLIST";
var PLACE_SVG_FROM_ICONLIST_SUCCESS = exports.PLACE_SVG_FROM_ICONLIST_SUCCESS = "PLACE_SVG_FROM_ICONLIST_SUCCESS";
var PLACE_SVG_FROM_ICONLIST_FAILURE = exports.PLACE_SVG_FROM_ICONLIST_FAILURE = "PLACE_SVG_FROM_ICONLIST_FAILURE";

var SAVE_CLEANED_SVG = exports.SAVE_CLEANED_SVG = "SAVE_CLEANED_SVG";

var FETCH_ICON = exports.FETCH_ICON = "FETCH_ICON";
var FETCH_ICON_SUCCESS = exports.FETCH_ICON_SUCCESS = "FETCH_ICON_SUCCESS";
var FETCH_ICON_FAILURE = exports.FETCH_ICON_FAILURE = "FETCH_ICON_FAILURE";

var SET_ACTIVE_ICON = exports.SET_ACTIVE_ICON = "SET_ACTIVE_ICON";
var CLEAR_ACTIVE_ICON = exports.CLEAR_ACTIVE_ICON = "CLEAR_ACTIVE_ICON";

var SET_ICON_COLOR_PALETTE = exports.SET_ICON_COLOR_PALETTE = "SET_ICON_COLOR_PALETTE";

var GET_ICON_META_DATA = exports.GET_ICON_META_DATA = "GET_ICON_META_DATA";

var SET_ICON_SIZE = exports.SET_ICON_SIZE = "SET_ICON_SIZE";

var SHOW_ICON_DETAIL = exports.SHOW_ICON_DETAIL = "SHOW_ICON_DETAIL";
var HIDE_ICON_DETAIL = exports.HIDE_ICON_DETAIL = "HIDE_ICON_DETAIL";

var SEARCH_ICONS = exports.SEARCH_ICONS = "SEARCH_ICONS";
var SEARCH_ICONS_SUCCESS = exports.SEARCH_ICONS_SUCCESS = "SEARCH_ICONS_SUCCESS";
var SEARCH_ICONS_FAILURE = exports.SEARCH_ICONS_FAILURE = "SEARCH_ICONS_FAILURE";

var FETCH_FEATURED_COLLECTIONS = exports.FETCH_FEATURED_COLLECTIONS = "FETCH_FEATURED_COLLECTIONS";
var FETCH_FEATURED_COLLECTIONS_SUCCESS = exports.FETCH_FEATURED_COLLECTIONS_SUCCESS = "FETCH_FEATURED_COLLECTIONS_SUCCESS";
var FETCH_FEATURED_COLLECTIONS_FAILURE = exports.FETCH_FEATURED_COLLECTIONS_FAILURE = "FETCH_FEATURED_COLLECTIONS_FAILURE";

var FETCH_FORT_ICON = exports.FETCH_FORT_ICON = "FETCH_FORT_ICON";
var FETCH_FORT_ICON_SUCCESS = exports.FETCH_FORT_ICON_SUCCESS = "FETCH_FORT_ICON_SUCCESS";
var FETCH_FORT_ICON_FAILURE = exports.FETCH_FORT_ICON_FAILURE = "FETCH_FORT_ICON_FAILURE";

var FORT_FETCH_MODERATORS = exports.FORT_FETCH_MODERATORS = "FORT_FETCH_MODERATORS";
var FORT_FETCH_MODERATORS_SUCCESS = exports.FORT_FETCH_MODERATORS_SUCCESS = "FORT_FETCH_MODERATORS_SUCCESS";
var FORT_FETCH_MODERATORS_FAILURE = exports.FORT_FETCH_MODERATORS_FAILURE = "FORT_FETCH_MODERATORS_FAILURE";
var FORT_SELECT_MODERATOR = exports.FORT_SELECT_MODERATOR = "FORT_SELECT_MODERATOR";

var REGENERATE_ICON_INFO = exports.REGENERATE_ICON_INFO = "REGENERATE_ICON_INFO";
var REGENERATE_ICON_INFO_SUCCESS = exports.REGENERATE_ICON_INFO_SUCCESS = "REGENERATE_ICON_INFO_SUCCESS";
var REGENERATE_ICON_INFO_FAILURE = exports.REGENERATE_ICON_INFO_FAILURE = "REGENERATE_ICON_INFO_FAILURE";

var DISABLE_ICON = exports.DISABLE_ICON = "DISABLE_ICON";
var DISABLE_ICON_SUCCESS = exports.DISABLE_ICON_SUCCESS = "DISABLE_ICON_SUCCESS";
var DISABLE_ICON_FAILURE = exports.DISABLE_ICON_FAILURE = "DISABLE_ICON_FAILURE";

var FEATURE_ICON = exports.FEATURE_ICON = "FEATURE_ICON";
var FEATURE_ICON_SUCCESS = exports.FEATURE_ICON_SUCCESS = "FEATURE_ICON_SUCCESS";
var FEATURE_ICON_FAILURE = exports.FEATURE_ICON_FAILURE = "FEATURE_ICON_FAILURE";

var UNFEATURE_ICON = exports.UNFEATURE_ICON = "UNFEATURE_ICON";
var UNFEATURE_ICON_SUCCESS = exports.UNFEATURE_ICON_SUCCESS = "UNFEATURE_ICON_SUCCESS";
var UNFEATURE_ICON_FAILURE = exports.UNFEATURE_ICON_FAILURE = "UNFEATURE_ICON_FAILURE";

var SELECT_ICON = exports.SELECT_ICON = "SELECT_ICON";
var DESELECT_ICON = exports.DESELECT_ICON = "DESELECT_ICON";
var SELECT_ALL_ICONS = exports.SELECT_ALL_ICONS = "SELECT_ALL_ICONS";
var UNSELECT_ALL_ICONS = exports.UNSELECT_ALL_ICONS = "UNSELECT_ALL_ICONS";

var FEATURE_COLLECTION = exports.FEATURE_COLLECTION = "FEATURE_COLLECTION";
var FEATURE_COLLECTION_SUCCESS = exports.FEATURE_COLLECTION_SUCCESS = "FEATURE_COLLECTION_SUCCESS";
var FEATURE_COLLECTION_FAILURE = exports.FEATURE_COLLECTION_FAILURE = "FEATURE_COLLECTION_FAILURE";

var UNFEATURE_COLLECTION = exports.UNFEATURE_COLLECTION = "UNFEATURE_COLLECTION";
var UNFEATURE_COLLECTION_SUCCESS = exports.UNFEATURE_COLLECTION_SUCCESS = "UNFEATURE_COLLECTION_SUCCESS";
var UNFEATURE_COLLECTION_FAILURE = exports.UNFEATURE_COLLECTION_FAILURE = "UNFEATURE_COLLECTION_FAILURE";

var APPROVE_ICONS = exports.APPROVE_ICONS = "APPROVE_ICONS";
var APPROVE_ICONS_SUCCESS = exports.APPROVE_ICONS_SUCCESS = "APPROVE_ICONS_SUCCESS";
var APPROVE_ICONS_FAILURE = exports.APPROVE_ICONS_FAILURE = "APPROVE_ICONS_FAILURE";

var SAVE_ICON_INFO = exports.SAVE_ICON_INFO = "SAVE_ICON_INFO";
var SAVE_ICON_INFO_SUCCESS = exports.SAVE_ICON_INFO_SUCCESS = "SAVE_ICON_INFO_SUCCESS";
var SAVE_ICON_INFO_FAILURE = exports.SAVE_ICON_INFO_FAILURE = "SAVE_ICON_INFO_FAILURE";

var DENY_ICONS = exports.DENY_ICONS = "DENY_ICONS";
var DENY_ICONS_SUCCESS = exports.DENY_ICONS_SUCCESS = "DENY_ICONS_SUCCESS";
var DENY_ICONS_FAILURE = exports.DENY_ICONS_FAILURE = "DENY_ICONS_FAILURE";

var DENIAL_REASONS = exports.DENIAL_REASONS = "DENIAL_REASONS";
var DENIAL_REASONS_SUCCESS = exports.DENIAL_REASONS_SUCCESS = "DENIAL_REASONS_SUCCESS";
var DENIAL_REASONS_FAILURE = exports.DENIAL_REASONS_FAILURE = "DENIAL_REASONS_FAILURE";

var SAVE_NAME = exports.SAVE_NAME = "SAVE_NAME";
var SAVE_TAGS = exports.SAVE_TAGS = "SAVE_TAGS";

var ICONS_FETCH_PURCHASED = exports.ICONS_FETCH_PURCHASED = "ICON_FETCH_PURCHASED";
var ICONS_FETCH_PURCHASED_SUCCESS = exports.ICONS_FETCH_PURCHASED_SUCCESS = "ICON_FETCH_PURCHASED_SUCCESS";
var ICONS_FETCH_PURCHASED_FAILURE = exports.ICONS_FETCH_PURCHASED_FAILURE = "ICON_FETCH_PURCHASED_FAILURE";

// Uploads
var FETCH_UPLOAD_ICONS = exports.FETCH_UPLOAD_ICONS = "FETCH_UPLOAD_ICONS";
var FETCH_UPLOAD_ICONS_SUCCESS = exports.FETCH_UPLOAD_ICONS_SUCCESS = "FETCH_UPLOAD_ICONS_SUCCESS";
var FETCH_UPLOAD_ICONS_FAILURE = exports.FETCH_UPLOAD_ICONS_FAILURE = "FETCH_UPLOAD_ICONS_FAILURE";

var PREVIEW_UPLOAD_ICONS = exports.PREVIEW_UPLOAD_ICONS = "PREVIEW_UPLOAD_ICONS";
var PREVIEW_UPLOAD_ICONS_SUCCESS = exports.PREVIEW_UPLOAD_ICONS_SUCCESS = "PREVIEW_UPLOAD_ICONS_SUCCESS";
var PREVIEW_UPLOAD_ICONS_FAILURE = exports.PREVIEW_UPLOAD_ICONS_FAILURE = "PREVIEW_UPLOAD_ICONS_FAILURE";

var FETCH_COMPLETED_ICONS = exports.FETCH_COMPLETED_ICONS = "FETCH_COMPLETED_ICONS";
var FETCH_COMPLETED_ICONS_SUCCESS = exports.FETCH_COMPLETED_ICONS_SUCCESS = "FETCH_COMPLETED_ICONS_SUCCESS";
var FETCH_COMPLETED_ICONS_FAILURE = exports.FETCH_COMPLETED_ICONS_FAILURE = "FETCH_COMPLETED_ICONS_FAILURE";

var FETCH_NEW_UPLOADS = exports.FETCH_NEW_UPLOADS = "FETCH_NEW_UPLOADS";
var FETCH_NEW_UPLOADS_SUCCESS = exports.FETCH_NEW_UPLOADS_SUCCESS = "FETCH_NEW_UPLOADS_SUCCESS";
var FETCH_NEW_UPLOADS_FAILURE = exports.FETCH_NEW_UPLOADS_FAILURE = "FETCH_NEW_UPLOADS_FAILURE";

var FETCH_SAVED_UPLOADS = exports.FETCH_SAVED_UPLOADS = "FETCH_SAVED_UPLOADS";
var FETCH_SAVED_UPLOADS_SUCCESS = exports.FETCH_SAVED_UPLOADS_SUCCESS = "FETCH_SAVED_UPLOADS_SUCCESS";
var FETCH_SAVED_UPLOADS_FAILURE = exports.FETCH_SAVED_UPLOADS_FAILURE = "FETCH_SAVED_UPLOADS_FAILURE";

var FETCH_SUSPENDED_UPLOADS = exports.FETCH_SUSPENDED_UPLOADS = "FETCH_SUSPENDED_UPLOADS";
var FETCH_SUSPENDED_UPLOADS_SUCCESS = exports.FETCH_SUSPENDED_UPLOADS_SUCCESS = "FETCH_SUSPENDED_UPLOADS_SUCCESS";
var FETCH_SUSPENDED_UPLOADS_FAILURE = exports.FETCH_SUSPENDED_UPLOADS_FAILURE = "FETCH_SUSPENDED_UPLOADS_FAILURE";

var FETCH_COMPLETED_UPLOADS = exports.FETCH_COMPLETED_UPLOADS = "FETCH_COMPLETED_UPLOADS";
var FETCH_COMPLETED_UPLOADS_SUCCESS = exports.FETCH_COMPLETED_UPLOADS_SUCCESS = "FETCH_COMPLETED_UPLOADS_SUCCESS";
var FETCH_COMPLETED_UPLOADS_FAILURE = exports.FETCH_COMPLETED_UPLOADS_FAILURE = "FETCH_COMPLETED_UPLOADS_FAILURE";

var COMPLETE_UPLOAD = exports.COMPLETE_UPLOAD = "COMPLETE_UPLOAD";
var COMPLETE_UPLOAD_SUCCESS = exports.COMPLETE_UPLOAD_SUCCESS = "COMPLETE_UPLOAD_SUCCESS";
var COMPLETE_UPLOAD_FAILURE = exports.COMPLETE_UPLOAD_FAILURE = "COMPLETE_UPLOAD_FAILURE";

var SAVE_UPLOAD_FOR_LATER = exports.SAVE_UPLOAD_FOR_LATER = "SAVE_UPLOAD_FOR_LATER";
var SAVE_UPLOAD_FOR_LATER_SUCCESS = exports.SAVE_UPLOAD_FOR_LATER_SUCCESS = "SAVE_UPLOAD_FOR_LATER_SUCCESS";
var SAVE_UPLOAD_FOR_LATER_FAILURE = exports.SAVE_UPLOAD_FOR_LATER_FAILURE = "SAVE_UPLOAD_FOR_LATER_FAILURE";

var SAVE_CREATOR_NOTE = exports.SAVE_CREATOR_NOTE = "SAVE_CREATOR_NOTE";
var SAVE_CREATOR_NOTE_SUCCESS = exports.SAVE_CREATOR_NOTE_SUCCESS = "SAVE_CREATOR_NOTE_SUCCESS";
var SAVE_CREATOR_NOTE_FAILURE = exports.SAVE_CREATOR_NOTE_FAILURE = "SAVE_CREATOR_NOTE_FAILURE";

var REVIEW_UPLOAD = exports.REVIEW_UPLOAD = "REVIEW_UPLOAD";
var REVIEW_UPLOAD_SUCCESS = exports.REVIEW_UPLOAD_SUCCESS = "REVIEW_UPLOAD_SUCCESS";
var REVIEW_UPLOAD_FAILURE = exports.REVIEW_UPLOAD_FAILURE = "REVIEW_UPLOAD_FAILURE";

var SEARCH_SAVED_UPLOADS = exports.SEARCH_SAVED_UPLOADS = "SEARCH_SAVED_UPLOADS";
var SEARCH_SAVED_UPLOADS_SUCCESS = exports.SEARCH_SAVED_UPLOADS_SUCCESS = "SEARCH_SAVED_UPLOADS_SUCCESS";
var SEARCH_SAVED_UPLOADS_FAILURE = exports.SEARCH_SAVED_UPLOADS_FAILURE = "SEARCH_SAVED_UPLOADS_FAILURE";

var SEARCH_SUSPENDED_UPLOADS = exports.SEARCH_SUSPENDED_UPLOADS = "SEARCH_SUSPENDED_UPLOADS";
var SEARCH_SUSPENDED_UPLOADS_SUCCESS = exports.SEARCH_SUSPENDED_UPLOADS_SUCCESS = "SEARCH_SUSPENDED_UPLOADS_SUCCESS";
var SEARCH_SUSPENDED_UPLOADS_FAILURE = exports.SEARCH_SUSPENDED_UPLOADS_FAILURE = "SEARCH_SUSPENDED_UPLOADS_FAILURE";

var SEARCH_COMPLETED_UPLOADS = exports.SEARCH_COMPLETED_UPLOADS = "SEARCH_COMPLETED_UPLOADS";
var SEARCH_COMPLETED_UPLOADS_SUCCESS = exports.SEARCH_COMPLETED_UPLOADS_SUCCESS = "SEARCH_COMPLETED_UPLOADS_SUCCESS";
var SEARCH_COMPLETED_UPLOADS_FAILURE = exports.SEARCH_COMPLETED_UPLOADS_FAILURE = "SEARCH_COMPLETED_UPLOADS_FAILURE";

var SEARCH_UPLOADS = exports.SEARCH_UPLOADS = "SEARCH_UPLOADS";
var SEARCH_UPLOADS_SUCCESS = exports.SEARCH_UPLOADS_SUCCESS = "SEARCH_UPLOADS_SUCCESS";
var SEARCH_UPLOADS_FAILURE = exports.SEARCH_UPLOADS_FAILURE = "SEARCH_UPLOADS_FAILURE";

var RATE_CREATOR = exports.RATE_CREATOR = "RATE_CREATOR";
var RATE_CREATOR_SUCCESS = exports.RATE_CREATOR_SUCCESS = "RATE_CREATOR_SUCCESS";
var RATE_CREATOR_FAILURE = exports.RATE_CREATOR_FAILURE = "RATE_CREATOR_FAILURE";

// plugin
var SET_ADOBE_AGENT = exports.SET_ADOBE_AGENT = "SET_ADOBE_AGENT";

var REPORT_PLUGIN_USAGE = exports.REPORT_PLUGIN_USAGE = "REPORT_PLUGIN_USAGE";
var REPORT_PLUGIN_USAGE_SUCCESS = exports.REPORT_PLUGIN_USAGE_SUCCESS = "REPORT_PLUGIN_USAGE_SUCCESS";
var REPORT_PLUGIN_USAGE_FAILURE = exports.REPORT_PLUGIN_USAGE_FAILURE = "REPORT_PLUGIN_USAGE_FAILURE";

var FETCH_PLUGIN_ICONS = exports.FETCH_PLUGIN_ICONS = "FETCH_PLUGIN_ICONS";
var FETCH_PLUGIN_ICONS_SUCCESS = exports.FETCH_PLUGIN_ICONS_SUCCESS = "FETCH_PLUGIN_ICONS_SUCCESS";
var FETCH_PLUGIN_ICONS_FAILURE = exports.FETCH_PLUGIN_ICONS_FAILURE = "FETCH_PLUGIN_ICONS_FAILURE";

var SET_PLUGIN_PAGE = exports.SET_PLUGIN_PAGE = "SET_PLUGIN_PAGE";
var SET_PLUGIN_HOST = exports.SET_PLUGIN_HOST = "SET_PLUGIN_HOST";
var PLACE_ICON = exports.PLACE_ICON = "PLACE_ICON";

var GET_PNG_URL = exports.GET_PNG_URL = "GET_PNG_URL";
var GET_PNG_URL_SUCCESS = exports.GET_PNG_URL_SUCCESS = "GET_PNG_URL_SUCCESS";
var GET_PNG_URL_FAILURE = exports.GET_PNG_URL_FAILURE = "GET_PNG_URL_FAILURE";

var FETCH_PNG_DATA = exports.FETCH_PNG_DATA = "FETCH_PNG_DATA";
var FETCH_PNG_DATA_SUCCESS = exports.FETCH_PNG_DATA_SUCCESS = "FETCH_PNG_DATA_SUCCESS";
var FETCH_PNG_DATA_FAILURE = exports.FETCH_PNG_DATA_FAILURE = "FETCH_PNG_DATA_FAILURE";

var PLACE_PNG_DATA_GSUITE = exports.PLACE_PNG_DATA_GSUITE = "PLACE_PNG_DATA_GSUITE";

var FETCH_PDF_DATA = exports.FETCH_PDF_DATA = "FETCH_PDF_DATA";
var FETCH_PDF_DATA_SUCCESS = exports.FETCH_PDF_DATA_SUCCESS = "FETCH_PDF_DATA_SUCCESS";
var FETCH_PDF_DATA_FAILURE = exports.FETCH_PDF_DATA_FAILURE = "FETCH_PDF_DATA_FAILURE";

// edu

var SEND_EDU_APPLICATION = exports.SEND_EDU_APPLICATION = "SEND_EDU_APPLICATION";
var SEND_EDU_APPLICATION_SUCCESS = exports.SEND_EDU_APPLICATION_SUCCESS = "SEND_EDU_APPLICATION_SUCCESS";
var SEND_EDU_APPLICATION_FAILURE = exports.SEND_EDU_APPLICATION_FAILURE = "SEND_EDU_APPLICATION_FAILURE";

// Downloads
var DOWNLOAD_RESET_FLOW = exports.DOWNLOAD_RESET_FLOW = "DOWNLOAD_RESET_FLOW";
var DOWNLOAD_FLOW_GO_BACK = exports.DOWNLOAD_FLOW_GO_BACK = "DOWNLOAD_FLOW_GO_BACK";
var DOWNLOAD_SET_FLOW_ACTIVE = exports.DOWNLOAD_SET_FLOW_ACTIVE = "DOWNLOAD_SET_FLOW_ACTIVE";
var DOWNLOAD_REQUEST = exports.DOWNLOAD_REQUEST = "DOWNLOAD_REQUEST";
var DOWNLOAD_SELECT_LICENSE = exports.DOWNLOAD_SELECT_LICENSE = "DOWNLOAD_SELECT_LICENSE";
var DOWNLOAD_COMMIT_LICENSE = exports.DOWNLOAD_COMMIT_LICENSE = "DOWNLOAD_COMMIT_LICENSE";
var DOWNLOAD_SELECT_ATTRIBUTION = exports.DOWNLOAD_SELECT_ATTRIBUTION = "DOWNLOAD_SELECT_ATTRIBUTION";
var DOWNLOAD_COMMIT_ATTRIBUTION = exports.DOWNLOAD_COMMIT_ATTRIBUTION = "DOWNLOAD_COMMIT_ATTRIBUTION";
var DOWNLOAD_SELECT_PURCHASE_TYPE = exports.DOWNLOAD_SELECT_PURCHASE_TYPE = "DOWNLOAD_SELECT_PURCHASE_TYPE";
var DOWNLOAD_SELECT_FORMAT = exports.DOWNLOAD_SELECT_FORMAT = "DOWNLOAD_SELECT_FORMAT";

var DOWNLOAD_PURCHASE_START = exports.DOWNLOAD_PURCHASE_START = "DOWNLOAD_PURCHASE_START";
var DOWNLOAD_PURCHASE_END = exports.DOWNLOAD_PURCHASE_END = "DOWNLOAD_PURCHASE_END";
var DOWNLOAD_START = exports.DOWNLOAD_START = "DOWNLOAD_START";
var DOWNLOAD_START_SUCCESS = exports.DOWNLOAD_START_SUCCESS = "DOWNLOAD_START_SUCCESS";
var DOWNLOAD_START_FAILURE = exports.DOWNLOAD_START_FAILURE = "DOWNLOAD_START_FAILURE";

var DOWNLOAD_PURCHASE = exports.DOWNLOAD_PURCHASE = "DOWNLOAD_PURCHASE";
var DOWNLOAD_PURCHASE_SUCCESS = exports.DOWNLOAD_PURCHASE_SUCCESS = "DOWNLOAD_PURCHASE_SUCCESS";
var DOWNLOAD_PURCHASE_FAILURE = exports.DOWNLOAD_PURCHASE_FAILURE = "DOWNLOAD_PURCHASE_FAILURE";

var DOWNLOAD_UPSELL_ACCEPTED = exports.DOWNLOAD_UPSELL_ACCEPTED = "DOWNLOAD_UPSELL_ACCEPTED";
var DOWNLOAD_UPSELL_REJECTED = exports.DOWNLOAD_UPSELL_REJECTED = "DOWNLOAD_UPSELL_REJECTED";
var DOWNLOAD_REPURCHASE = exports.DOWNLOAD_REPURCHASE = "DOWNLOAD_REPURCHASE";
var DOWNLOAD_JUMP_TO_LICENSE = exports.DOWNLOAD_JUMP_TO_LICENSE = "DOWNLOAD_JUMP_TO_LICENSE";
var DOWNLOAD_COMPLETE_SUCCESS = exports.DOWNLOAD_COMPLETE_SUCCESS = "DOWNLOAD_COMPLETE_SUCCESS";
var DOWNLOAD_COMPLETE_FAILURE = exports.DOWNLOAD_COMPLETE_FAILURE = "DOWNLOAD_COMPLETE_FAILURE";

var STRIPE_CREATE_TOKEN = exports.STRIPE_CREATE_TOKEN = "STRIPE_CREATE_TOKEN";
var STRIPE_CREATE_TOKEN_SUCCESS = exports.STRIPE_CREATE_TOKEN_SUCCESS = "STRIPE_CREATE_TOKEN_SUCCESS";
var STRIPE_CREATE_TOKEN_FAILURE = exports.STRIPE_CREATE_TOKEN_FAILURE = "STRIPE_CREATE_TOKEN_FAILURE";

var STRIPE_CARD_INPUT_CHANGE = exports.STRIPE_CARD_INPUT_CHANGE = "STRIPE_CARD_INPUT_CHANGE";
var STRIPE_CARD_INPUT_ERROR = exports.STRIPE_CARD_INPUT_ERROR = "STRIPE_CARD_INPUT_ERROR";
var STRIPE_SAVE_CARD_CHANGE = exports.STRIPE_SAVE_CARD_CHANGE = "STRIPE_SAVE_CARD_CHANGE";

var STRIPE_GET_SAVED_CARD = exports.STRIPE_GET_SAVED_CARD = "STRIPE_GET_SAVED_CARD";
var STRIPE_GET_SAVED_CARD_SUCCESS = exports.STRIPE_GET_SAVED_CARD_SUCCESS = "STRIPE_GET_SAVED_CARD_SUCCESS";
var STRIPE_GET_SAVED_CARD_FAILURE = exports.STRIPE_GET_SAVED_CARD_FAILURE = "STRIPE_GET_SAVED_CARD_FAILURE";

var STRIPE_USE_NEW_CARD = exports.STRIPE_USE_NEW_CARD = "STRIPE_USE_NEW_CARD";

var STRIPE_SET_SHOW_BILLING_INFO = exports.STRIPE_SET_SHOW_BILLING_INFO = "STRIPE_SET_SHOW_BILLING_INFO";
var STRIPE_UPDATE_BILLING_INFO = exports.STRIPE_UPDATE_BILLING_INFO = "STRIPE_UPDATE_BILLING_INFO";

// UI
var UI_BODY_CLASS_ADD = exports.UI_BODY_CLASS_ADD = "UI_BODY_CLASS_ADD";
var UI_BODY_CLASS_REMOVE = exports.UI_BODY_CLASS_REMOVE = "UI_BODY_CLASS_REMOVE";
var UI_SCROLL_TO_ELEMENT = exports.UI_SCROLL_TO_ELEMENT = "UI_SCROLL_TO_ELEMENT";
var EXPERIMENTS_SET = exports.EXPERIMENTS_SET = "EXPERIMENTS_SET";

var EDITOR_RESET = exports.EDITOR_RESET = "EDITOR_RESET";
var EDITOR_TRANSFORM = exports.EDITOR_TRANSFORM = "EDITOR_TRANSFORM";
var EDITOR_TRANSFORMED = exports.EDITOR_TRANSFORMED = "EDITOR_TRANSFORMED";
var EDITOR_ADD_COLOR = exports.EDITOR_ADD_COLOR = "EDITOR_ADD_COLOR";
var EDITOR_SET_PALETTE_MODE = exports.EDITOR_SET_PALETTE_MODE = "EDITOR_SET_PALETTE_MODE";
var EDITOR_EXPORT = exports.EDITOR_EXPORT = "EDITOR_EXPORT";
var EDITOR_EXPORT_SUCCESS = exports.EDITOR_EXPORT_SUCCESS = "EDITOR_EXPORT_SUCCESS";
var EDITOR_EXPORT_FAILURE = exports.EDITOR_EXPORT_FAILURE = "EDITOR_EXPORT_FAILURE";
var EDITOR_CACHE_SVG = exports.EDITOR_CACHE_SVG = "EDITOR_CACHE_SVG";